module.exports = __webpack_public_path__ + "img/beijin.7a956fc7.png";